import { RootState } from "../store";

export const hallsSelector = (state: RootState) => state.halls;
